import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { assetStorageApi } from 'src/Services/API';

const useFetchDocument = (fileId?: string) => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fetch-document', assetId, fileId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      if (!fileId) throw new Error('No fileId provided');
      return (await assetStorageApi.assetStorageControllerFindOne(assetId, fileId)).data;
    },
    enabled: !!assetId && !!fileId,
    staleTime: 5 * 60 * 1000,
  });
};

export default useFetchDocument;
